import React from 'react';
import { Badge } from 'react-bootstrap';


const KindergartenBadge = ({kindergartenData})=> {
    if(!kindergartenData || !kindergartenData.badges ) return null;
    return(
              <div className="kindergarten-badges">
                {kindergartenData.badges.map((badge, index) => (
                  <Badge 
                    key={index} 
                    bg={badge.variant} 
                    className="me-2 mb-2"
                  >
                    {badge.text}
                  </Badge>
                ))}
                <span className="text-muted">Немає післяобідні місця</span>
              </div>
    )
}

export default KindergartenBadge;